import OverviewButton from '../Buttons/overviewButton';

export default function OfflineButtons() {
	return <OverviewButton />;
}
